import React from 'react';
import { useTranslation } from 'react-i18next';
import { reimbursementModStyles } from './ReimbursementMod.styles';
import { Grid, InputAdornment, Stack, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { getNumberFormattedValue, isNumber } from '../../ModificationsUtils';

export const AmountPerMile = ({ isExpanded, isModEdit }: { isExpanded: boolean; isModEdit: boolean }) => {
  const { t } = useTranslation();
  const { control, getValues } = useFormContext();
  const { classes } = reimbursementModStyles({ isExpanded });

  return (
    <Grid>
      <Grid item xs={12}>
        <Controller
          name="amountPerMile"
          control={control}
          render={({field: { onChange, ...rest } }) => (
            <Stack>
              <TextField
                value={getNumberFormattedValue(getValues('amountPerMile'))}
                className={classes.dollarTextfields}
                InputLabelProps={{
                  shrink: isNumber(getValues('amountPerMile')) ?? false,
                }}
                variant="filled"
                label={t(`placement.placementMods.reimbAmountPerMile`)}
                InputProps={{
                  readOnly: !isModEdit,
                  style: {
                    pointerEvents: 'none',
                  },
                  startAdornment: (
                    <>
                      {isNumber(getValues('amountPerMile')) && (
                        <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>
                      )}
                    </>
                  ),
                  sx: { fontSize: '14px' },
                }}
                {...rest}
              />
            </Stack>
          )}
        />
      </Grid>
    </Grid>
  );
};
